import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'

import user from './user'
import options from './options'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    options,
    app
  },
  plugins: [createPersistedState({
    rehydrated: store => {
      axios.defaults.headers.common['Authorization'] = `JWT ${store.state.user.token}`
    },
    paths: [ 'user' ]
  })],
})



// WEBPACK FOOTER //
// ./src/store/index.js